import { render, staticRenderFns } from "./ximei_list.vue?vue&type=template&id=0562ad1e&scoped=true&"
import script from "./ximei_list.vue?vue&type=script&lang=js&"
export * from "./ximei_list.vue?vue&type=script&lang=js&"
import style0 from "./ximei_list.vue?vue&type=style&index=0&id=0562ad1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0562ad1e",
  null
  
)

export default component.exports